import type { ReactNode } from "react";
import type { TourProps, TourStepProps } from "antd";
import type { Locale } from "antd/es/locale";

/** 高亮区域与锚点间距、圆角（对齐 @rc-component/tour Gap） */
export interface GuideTourGap {
  offset?: number | [number, number];
  radius?: number;
}

/** 引导步骤配置 */
export interface GuideTourStep {
  /** 步骤标题，支持 string / JSX 等 ReactNode */
  title: ReactNode;
  /** 步骤描述，支持 string / JSX 等 ReactNode */
  description?: ReactNode;
  /** 自定义正文（优先于 description，同样支持 ReactNode） */
  content?: ReactNode;
  /** 锚点元素；null 表示居中展示（回调返回 null 时由内部兼容） */
  target?: HTMLElement | (() => HTMLElement | null) | null;
  /** 相对锚点的气泡位置（left/right 默认顶对齐；top/bottom 可传 Left/Right 控制横向对齐） */
  placement?: TourStepProps["placement"];
  /** 当前步骤的高亮区间距（会合并到 Tour 的 gap） */
  gap?: GuideTourGap;
  /** 是否展示指向箭头 */
  arrow?: TourStepProps["arrow"];
}

/** 引导底部按钮文案 */
export interface GuideTourLabels {
  skip?: string;
  prev?: string;
  next?: string;
  finish?: string;
}

/** 引导卡片默认宽度（px） */
export const GUIDE_TOUR_DEFAULT_PANEL_WIDTH = 380;

export interface GuideTourProps {
  /** 是否展示引导 */
  open: boolean;
  /** 步骤列表 */
  steps: GuideTourStep[];
  /** 受控当前步骤（0-based） */
  current?: number;
  /** 非受控初始步骤 */
  defaultCurrent?: number;
  /** 步骤切换 */
  onChange?: (current: number) => void;
  /** 完成最后一步 */
  onFinish?: () => void;
  /** 点击跳过引导 */
  onSkip?: () => void;
  /** 引导关闭（含跳过） */
  onClose?: () => void;
  /** 底部按钮文案 */
  labels?: GuideTourLabels;
  /** 遮罩配置 */
  mask?: TourProps["mask"];
  /** 默认高亮区间距（当前步骤未指定 gap 时使用） */
  gap?: GuideTourGap;
  /** 引导卡片宽度，默认 380px */
  panelWidth?: number | string;
  rootClassName?: string;
  className?: string;
  /** antd 语言包 */
  locale?: Locale;
  /** 弹层挂载容器（qiankun 子应用内需传入 getSubAppPortalContainer） */
  getPopupContainer?: TourProps["getPopupContainer"];
}
